import React from 'react';
import { T } from 'shared/helper/translate';
var OrderRestorationMessage = function OrderRestorationMessage(_ref) {
  var orderFormInProgress = _ref.orderFormInProgress;
  return orderFormInProgress ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    useLink: true,
    source: "dashboard-unfinished-order-alert"
  })))) : null;
};
export default OrderRestorationMessage;